import { NoticeDetail } from '@/components/NoticeDetail'
import { Button, Ellipsis, Modal, State } from '@seiue/ui'
import { $t } from 'packages/locale'
import { notificationApi } from 'packages/sdks-next/growp'
import { FC, useContext } from 'react'
import styled from 'styled-components'

import { GatewayContext } from './context'
import corner from './corner.svg'

/**
 * 热点资讯卡片
 *
 * @returns card
 */
export const HotNewsCard: FC = () => {
  const { data: hotNews, loading } =
    notificationApi.useQueryFrontendInformations({
      isReceived: true,
      page: 1,
      perPage: 5,
      expand: ['currentRecever', 'senderName'],
    })

  const { setModule } = useContext(GatewayContext)

  if (loading) return <State.Loading />
  if (!hotNews?.length) return null

  return (
    <Box className="news-card">
      <Corner src={corner} />
      <Corner2 />
      <Title>{$t('关注资讯')}</Title>
      {hotNews?.map((news, index) => (
        <NewsItemMain
          key={news.id}
          onClick={async () => {
            if ((news.setting as { isLink?: boolean } | undefined)?.isLink) {
              // 打开新的窗口
              window.open(news.content)
            } else {
              Modal.open({
                title: '资讯详情',
                children: <NoticeDetail notification={news} />,
                footer: null,
                width: 960,
                height: 600,
                bodyStyle: { padding: 20 },
              })
            }

            await notificationApi.readNotification(news.id)
          }}
        >
          <Index $color={getIndexColor(index)}>{`${index + 1}.`}</Index>
          <NewsTitle text={news.title || '-'} />
        </NewsItemMain>
      ))}
      <Button
        type="gray"
        style={{
          width: '100%',
        }}
        onClick={() => {
          setModule('news')
        }}
      >
        {$t('查看全部')}
      </Button>
    </Box>
  )
}

const getIndexColor = (index: number) => {
  switch (index) {
    case 0:
      return '#FF4620'
    case 1:
      return '#FF7300'
    case 2:
      return '#FDCC17'
    default:
      return '#AFBDC7'
  }
}

const Corner = styled.img`
  position: absolute;
  top: -18px;
  left: calc(100% - 58px);
  width: 76px;
  z-index: 1;
`

const Corner2 = styled.div`
  width: 42px;
  height: 42px;
  background: #fff;
  clip-path: polygon(100% 0%, 100% 100%, 0% 0%);
  position: absolute;
  right: 0;
  top: -2px;
  border: none;
`

const Box = styled.div`
  position: relative;
  border-radius: 12px;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.brand._5} 0%, #ffffff 57%)`};
  box-shadow: 0px 3px 8px -1px rgba(21, 29, 41, 0.0392);
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  grid-column: -2 / -1;
  grid-row: 1 / 3;
  position: relative;
  z-index: 0; // 保证主内容在上层

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 12px 0 12px 12px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0), #e1ebf0);
    padding: 1px;
    box-sizing: border-box;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
    pointer-events: none;
  }
`

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: ${({ theme }) => theme.text._1};
`

const NewsItemMain = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

const Index = styled.div<{ $color: string }>`
  font-size: 17px;
  font-weight: bold;
  line-height: 24px;
  color: ${({ $color }) => $color};
  width: 14px;
`

const NewsTitle = styled(Ellipsis)`
  font-size: 15px;
  line-height: 24px;
  color: ${({ theme }) => theme.text._1};
  &:hover {
    color: ${({ theme }) => theme.brand.text0};
  }
`
